import React, { useCallback } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsChevronRight } from '@deephaven/icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ContextMenuItem = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var _menuItem$shortcutTex, _menuItem$shortcut;
  var closeMenu = _ref.closeMenu,
    children = _ref.children,
    menuItem = _ref.menuItem,
    onMenuItemClick = _ref.onMenuItemClick,
    onMenuItemMouseMove = _ref.onMenuItemMouseMove,
    onMenuItemContextMenu = _ref.onMenuItemContextMenu,
    _ref$isKeyboardSelect = _ref.isKeyboardSelected,
    isKeyboardSelected = _ref$isKeyboardSelect === void 0 ? false : _ref$isKeyboardSelect,
    _ref$isMouseSelected = _ref.isMouseSelected,
    isMouseSelected = _ref$isMouseSelected === void 0 ? false : _ref$isMouseSelected,
    dataTestId = _ref['data-testid'];
  var handleMenuItemClick = useCallback(e => {
    onMenuItemClick(menuItem, e);
  }, [menuItem, onMenuItemClick]);
  var handleMenuItemMouseMove = useCallback(e => {
    onMenuItemMouseMove(menuItem, e);
  }, [menuItem, onMenuItemMouseMove]);
  var handleMenuItemContextMenu = useCallback(e => {
    onMenuItemContextMenu(menuItem, e);
  }, [menuItem, onMenuItemContextMenu]);
  function renderCustomMenuElement(element, iconElement, displayShortcut) {
    // Don't pass forwardedProps if menuElement is a native DOM node
    if (typeof element.type === 'string') {
      return element;
    }
    var forwardedProps = {
      menuItem,
      closeMenu,
      isKeyboardSelected,
      isMouseSelected,
      iconElement,
      displayShortcut,
      'data-testid': dataTestId
    };
    return /*#__PURE__*/React.cloneElement(element, {
      forwardedProps
    });
  }
  var displayShortcut = (_menuItem$shortcutTex = menuItem.shortcutText) !== null && _menuItem$shortcutTex !== void 0 ? _menuItem$shortcutTex : (_menuItem$shortcut = menuItem.shortcut) === null || _menuItem$shortcut === void 0 ? void 0 : _menuItem$shortcut.getDisplayText();
  var icon = null;
  if (menuItem.icon) {
    var menuItemIcon = menuItem.icon;
    if (/*#__PURE__*/React.isValidElement(menuItemIcon)) {
      icon = menuItemIcon;
    } else {
      var style;
      if (menuItem.iconColor != null && (menuItem.disabled === undefined || !menuItem.disabled)) {
        style = {
          color: menuItem.iconColor
        };
      }
      icon = /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: menuItemIcon,
        style: style
      });
    }
  }
  var subMenuIndicator = null;
  var isSubMenuActive = Boolean(children);
  if (menuItem.actions) {
    subMenuIndicator = /*#__PURE__*/_jsx(FontAwesomeIcon, {
      icon: vsChevronRight
    });
  }
  var content = null;
  if (menuItem.menuElement) {
    content = /*#__PURE__*/_jsx("div", {
      className: "custom-menu-item",
      onMouseMove: handleMenuItemMouseMove,
      children: renderCustomMenuElement(menuItem.menuElement, icon, displayShortcut)
    });
  } else {
    var _menuItem$description;
    var menuItemDisabled = menuItem.disabled;
    var iconHasOutline = menuItem.iconOutline;
    content = /*#__PURE__*/_jsx("button", {
      type: "button",
      className: classNames('btn-context-menu', {
        disabled: menuItemDisabled
      }, {
        active: (isSubMenuActive || isMouseSelected) && (menuItemDisabled === undefined || !menuItemDisabled)
      }, {
        'keyboard-active': isKeyboardSelected && (menuItemDisabled === undefined || !menuItemDisabled)
      }),
      onClick: handleMenuItemClick,
      onMouseMove: handleMenuItemMouseMove,
      onContextMenu: handleMenuItemContextMenu,
      title: (_menuItem$description = menuItem.description) !== null && _menuItem$description !== void 0 ? _menuItem$description : '',
      children: /*#__PURE__*/_jsxs("div", {
        className: "btn-context-menu-wrapper",
        children: [/*#__PURE__*/_jsx("span", {
          className: classNames('icon', {
            outline: iconHasOutline
          }),
          children: icon
        }), /*#__PURE__*/_jsx("span", {
          className: "title",
          children: menuItem.title
        }), displayShortcut !== undefined && /*#__PURE__*/_jsx("span", {
          className: "shortcut",
          children: displayShortcut
        }), subMenuIndicator && /*#__PURE__*/_jsx("span", {
          className: classNames('submenu-indicator', {
            disabled: menuItemDisabled
          }),
          children: subMenuIndicator
        })]
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "context-menu-item",
    ref: ref,
    "data-testid": dataTestId,
    children: [children, content]
  });
});
ContextMenuItem.displayName = 'ContextMenuItem';
export default ContextMenuItem;
//# sourceMappingURL=ContextMenuItem.js.map